import React from 'react';
import { useRouter } from 'next/router';
import MenuIcon from '@mui/icons-material/Menu';
import { ListItemIcon, ListItemText, MenuList, MenuItem, Box } from '@mui/material';
import Divider from '@mui/material/Divider';
import { useMenu } from 'src/hooks/useMenu';
import Menu from '../Menu';
import * as S from './SideBarMenu.styles';
const SideBarMenu = () => {
  const {
    asPath,
    ...router
  } = useRouter();
  const items = useMenu();
  return /*#__PURE__*/React.createElement(Menu, {
    trigger: /*#__PURE__*/React.createElement(MenuIcon, {
      "data-testid": "MenuIcon"
    })
  }, /*#__PURE__*/React.createElement(MenuList, null, items.map(({
    label,
    children
  }, index) => /*#__PURE__*/React.createElement(Box, {
    key: `${label}=item-menu-list`
  }, /*#__PURE__*/React.createElement(S.Label, null, label), children.map(item => /*#__PURE__*/React.createElement(MenuItem, {
    key: item.label,
    selected: asPath.split('/')[1] === item.href?.substring(1),
    onClick: () => router.push(item.href).then(() => item?.effect?.())
  }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.Icon), /*#__PURE__*/React.createElement(ListItemText, {
    primaryTypographyProps: {
      variant: 'Lato Emphasized 2'
    }
  }, item.content || item.label))), index !== items.length - 1 && /*#__PURE__*/React.createElement(Divider, {
    key: label
  })))));
};
export default SideBarMenu;